export default __webpack_public_path__ + "images/180dda869cb8c04f7a0dfdb5408acd1b-error.svg";